import { NextSeo } from "next-seo";
import ExploreContent from "domains/explore/components/ExploreContent";

export default function ExplorePage() {
  return (
    <>
      <NextSeo title="Explore" />

      <ExploreContent context="explore" />
    </>
  );
}
